import Icons from "../../assets/icon/index";
import localimgpath from "../../js/localimgpath";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../register/custom-datepicker.css";
import Cropper from "react-easy-crop"; // Add cropper
import Modal from "react-modal"; // Add modal
import malePlaceholder from "../../assets/image/male.png";
import femalePlaceholder from "../../assets/image/female.png";
import otherPlaceholder from "../../assets/image/male.png"; // if you have
import bannerPlaceholder from "../../assets/image/gem bann web@3x.png"; // Banner placeholder
import {
  PrefilledDropDown,
  Newlogo,
  DefaultValueCountry,
  FormInput,
  HoverButton,
} from "../../components";

import { IoClose } from "react-icons/io5";
import { FiEdit2 } from "react-icons/fi";
import Functions from "./index.functions";

Modal.setAppElement("#root"); // Accessibility

const ProfileInformation = () => {
  const {
    navigate,
    userprofile,
    files,
    handleFileChange,
    clearFileChange,
    handleSubmit,
    onSubmit,
    control,
    errors,
    register,
    setValue,
    setCountryCode,
    setCca2,
    dropdowns,
    isLoadingprefilled,
    usernameType,
    isLoading,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    isDragging,
    handleDrop,
    handleDragEnter,
    handleDragLeave,
    isVoteToWinRequired,
    isVoteToWinImageSelected,
    loadingToapi,
    // Cropper related
    cropperOpen,
    cropperType,
    imageToCrop,
    crop,
    zoom,
    setCrop,
    setZoom,
    onCropComplete,
    handleCropSave,
    handleCropCancel,
    getCropperAspectRatio,
    getCropperTitle,
    currentGenderId,
  } = Functions();

  return (
    <div className="bg-primary scroll-container h-screen">
      <div className="sm:py-7 lg:py-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center relative xs:py-5">
          <Newlogo />
        </div>
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center flex-col relative lg:py-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl lg:leading-tight">
            Profile Information
          </h1>
          <p className="text-secondary lg:pt-5 font-montserratMedium xs:text-xs lg:text-lg">
            Welcome! Please enter your details.
          </p>
        </div>
        {/* ⭐ PROFILE IMAGE WITH PLACEHOLDER & PENDING CHECK */}
        <div className="mt-7 sm:mt-5 w-full flex justify-center items-center">
          <div className="relative w-28 h-28 sm:w-40 sm:h-40 rounded-full border-[3px] sm:border-4 border-goldMetallic group">

            <img
              className="w-full h-full object-cover rounded-full"
              src={
                // If user just selected a new file → preview it
                files.image
                  ? URL.createObjectURL(files.image)

                  // If no image uploaded yet OR backend status = pending → show placeholder
                  : !userprofile?.image ||
                    userprofile?.image_status === "pending" ||
                    userprofile?.image_status === null

                  ? // ⭐ Correct gender ID mapping
                    currentGenderId === "2"
                      ? malePlaceholder         // 2 = Male
                      : currentGenderId === "1"
                      ? femalePlaceholder       // 1 = Female
                      : otherPlaceholder        // 15 = Other, 16 = Bisexual

                  // Otherwise → show approved backend image
                  : `${localimgpath?.usersProfile}/${userprofile?.image}`
              }
              alt="Profile"
            />

            {/* Edit Icon */}
            <label
              htmlFor="image_Upload"
              className="absolute bottom-1.5 right-0 sm:right-1.5 bg-[#393939] text-secondary p-1.5 rounded-full cursor-pointer transition duration-300 group-hover:scale-110 hover:bg-orangeCrayola"
              title="Edit Image"
            >
              <FiEdit2 className="text-base sm:text-lg" />
            </label>

            <input
              id="image_Upload"
              type="file"
              accept="image/*"
              name="image"
              onChange={handleFileChange}
              className="hidden"
            />
          </div>
        </div>



        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div
            className={
              "flex xs:flex-col sm:w-[85%] xs:w-full lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                label={"First Name"}
                control={control}
                userData={userprofile}
                maxLength={30}
                isMandatory={true}
                isRequired={true}
                pattern={{
                  value: /^[A-Za-z\s]+$/,
                  message: "First Name can only contain letters",
                }}
                name="first_name"
                type="text"
                placeholder="First Name"
                errors={errors}
              />
            </div>
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                label={"Last Name"}
                control={control}
                userData={userprofile}
                maxLength={30}
                isMandatory={true}
                isRequired={true}
                pattern={{
                  value: /^[A-Za-z\s]+$/,
                  message: "Last Name can only contain letters",
                }}
                name="last_name"
                type="text"
                placeholder="Last Name"
                errors={errors}
              />
            </div>
          </div>
          <div className="flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4">
            {/* Date of Birth Field */}
            <Controller
                control={control}
                name="dob"
                rules={{
                  required: "Date of Birth is required",
                }}
                render={({ field }) => (
                  <div className="relative mt-[18px] sm:w-1/2">
                    <p className=" xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate   undefined ">Date of Birth <span className="text-errorRed">*</span></p>
                    <DatePicker
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="MM/dd/yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      maxDate={new Date()}
                      placeholderText="Select Date of Birth"
                      className="appearance-none xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic pr-12"
                    />
                    <svg
                      className="pointer-events-none absolute right-6 top-[60px] -translate-y-1/2"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 9L12 15L18 9"
                        stroke="#808080"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {errors.dob && (
                      <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                        {errors.dob.message}
                      </span>
                    )}
                  </div>
                )}
              />


            {/* ⭐ Gender Field */}
            <div className="relative mt-[18px] sm:w-1/2">
              <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate">
                Gender <span className="text-errorRed">*</span>
              </p>
              <Controller
                name="gender_id"
                control={control}
                rules={{ required: "Gender is required" }}
                render={({ field }) => (
                  <select
                    {...field}
                    value={field.value || ""}
                    className="appearance-none xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic pr-12"
                disabled={isLoading}
              >
                <option value="">Select Gender</option>

                {dropdowns?.gender?.length > 0 ? (
                  dropdowns.gender.map((g) => (
                    <option key={g.id} value={String(g.gender_id)}>
                      {g.gender}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading...</option>
                )}
              </select>
                )}
              />

              {errors.gender_id && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  {errors.gender_id.message}
                </span>
              )}

              {/* Dropdown arrow */}
              <svg
                className="pointer-events-none absolute right-6 top-[60px] -translate-y-1/2"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="#808080"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

          </div>

          {/* ✅ NEW: USERNAME TYPE SELECTOR */}
          <div className="flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4 mt-[18px]">
            <div className="relative w-full">
              <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate">
                Select Username Type <span className="text-errorRed">*</span>
              </p>
              <Controller
                name="usernameType"
                control={control}
                rules={{ required: "Username type is required" }}
                render={({ field }) => (
                  <div className="flex gap-6 xs:pl-6 sm:pl-6 lg:pl-8">
                    <label className="flex items-center cursor-pointer group">
                      <input
                        type="radio"
                        {...field}
                        value="email"
                        checked={field.value === "email"}
                        className="w-5 h-5 text-goldMetallic bg-[#171717] border-[#808080] focus:ring-goldMetallic focus:ring-2"
                      />
                      <span className="ml-2 text-secondary font-onestRegular xs:text-sm sm:text-base lg:text-lg group-hover:text-goldMetallic transition-colors">
                        Email
                      </span>
                    </label>
                    <label className="flex items-center cursor-pointer group">
                      <input
                        type="radio"
                        {...field}
                        value="phone"
                        checked={field.value === "phone"}
                        className="w-5 h-5 text-goldMetallic bg-[#171717] border-[#808080] focus:ring-goldMetallic focus:ring-2"
                      />
                      <span className="ml-2 text-secondary font-onestRegular xs:text-sm sm:text-base lg:text-lg group-hover:text-goldMetallic transition-colors">
                        Phone
                      </span>
                    </label>
                  </div>
                )}
              />
              {errors.usernameType && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  {errors.usernameType.message}
                </span>
              )}
            </div>
          </div>

          <div className="flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4">
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                label="Email Address"
                control={control}
                userData={userprofile}
                name="email"
                type="email"
                isMandatory={usernameType === "email"}
                rules={{
                  required: usernameType === "email" ? "Email is required" : false,
                  pattern: {
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Please enter a valid email address",
                  },
                }}
                errors={errors}
                disabled={usernameType === "phone"}
              />

            </div>
            <div className="relative mt-[18px] sm:w-1/2">
              <DefaultValueCountry
                label="Phone Number"
                type="text"
                name="mobile_num"
                defaultValue={userprofile?.mobile_num}
                countryCode={userprofile?.country_code}
                cca2 = {userprofile?.cca2}
                isMandatory={true}
                register={register}
                control={control}
                onChange={(value) => setValue("mobile_num", value)}
                errors={errors}
                setCountryCode={setCountryCode}
                setCca2={setCca2}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col sm:w-[85%] xs:w-full lg:w-[70%] sm:gap-2 lg:gap-4 mt-[18px]"
            }
          >
            <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label="Country"
                options={dropdowns?.country || []}
                isMandatory={true}
                valueName="country"
                valueoption="country_id"
                name="country_id"
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoading}
              />
            </div>
            <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"Province / State"}
                options={states}
                valueName="state"
                valueoption="state_id"
                name={"state_id"}
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoadingStates}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col sm:w-[85%] xs:w-full lg:w-[70%] sm:gap-2 lg:gap-4 mt-[18px]"
            }
          >
            <div className="w-full">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"City"}
                options={cities}
                valueName="city"
                valueoption="city_id"
                name={"city_id"}
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={citiesisLoading}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col sm:w-[85%] xs:w-full lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            {/* <div className="relative mt-[18px] w-full">
              <FormInput
                label="Referral Code (Optional)"
                control={control}
                userData={userprofile}
                name="referral_code"
                type="text"
                placeholder="Enter Referral Code"
                errors={errors}
              />
            </div> */}
          </div>
          <div className="mt-4 sm:w-[85%] xs:w-full lg:w-[70%]">
            <Controller
              name="agree_to_vote_to_win"
              control={control}
              render={({ field }) => (
                <div className="flex items-start gap-3 sm:gap-4">
                  <input
                    type="checkbox"
                    id="agree_to_vote_to_win"
                    {...field}
                    checked={field.value === true}
                    onChange={(e) => field.onChange(e.target.checked)}
                    className="mt-1 w-5 h-5 sm:w-6 sm:h-6 rounded border-2 border-goldMetallic bg-[#171717] text-goldMetallic focus:ring-2 focus:ring-goldMetallic checked:bg-goldMetallic cursor-pointer"
                  />
                  <label
                    htmlFor="agree_to_vote_to_win"
                    className="text-secondary font-onestRegular xs:text-sm sm:text-base lg:text-lg leading-relaxed cursor-pointer"
                  >
                    I agree to participate in the{" "}
                    <span className="text-goldMetallic font-onestSemiBold">
                      Vote to Win
                    </span>{" "}
                    competition and allow my profile to be publicly displayed
                    for voting purposes.
                  </label>
                </div>
              )}
            />
            {isVoteToWinRequired && (
              <>
                <div className="mt-6">
                  <div className="relative">
                    <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate">
                      Vote To Win Banner Image{" "}
                      <span className="text-errorRed">*</span>
                    </p>
                    <>
                      {userprofile?.vote_to_win_image &&
                        !files.voteToWinImage && (
                          <div className="mb-4 xs:pl-6 sm:pl-6 lg:pl-8">
                            <p className="text-[#808080] font-onestRegular xs:text-xs sm:text-sm lg:text-base mb-2">
                              Current Banner:
                            </p>
                            <img
                              src={`${localimgpath?.vote_to_win_image}/${userprofile?.vote_to_win_image}`}
                              alt="Current Vote to Win Banner"
                              className="w-full max-w-xs rounded-lg border-2 border-goldMetallic"
                            />
                          </div>
                        )}
                      <div
                        className={`flex flex-col items-center justify-center xs:pl-6 xs:pr-6 sm:pl-6 lg:pl-8 lg:pr-8 sm:pr-6 xs:py-8 sm:py-10 lg:py-12 bg-[#171717] rounded-[20px] cursor-pointer transition-all duration-300 ${
                          isDragging.voteToWinImage
                            ? "border-2 border-dashed border-orangeCrayola"
                            : "border-dashed border-transparent"
                        }`}
                        onDrop={(e) => handleDrop(e, "voteToWinImage")}
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={() => handleDragEnter("voteToWinImage")}
                        onDragLeave={() => handleDragLeave("voteToWinImage")}
                      >
                        {files.voteToWinImage ? (
                          <div className="flex w-full justify-between items-center">
                            <div className="flex items-center xs:gap-1 sm:gap-2 lg:gap-2">
                              <div>
                                <img
                                  className="sm:w-10 xs:w-8 lg:w-11 rounded"
                                  src={URL.createObjectURL(
                                    files.voteToWinImage
                                  )}
                                  alt={files.voteToWinImage.name}
                                />
                              </div>
                              <div>
                                <p className="text-[#808080] font-onestRegular xs:text-sm sm:text-sm lg:text-lg">
                                  {files.voteToWinImage.name}
                                </p>
                                <p className="text-[#808080] font-onestLight xs:text-sm sm:text-sm lg:text-lg">
                                  {files.voteToWinImage.size < 1024 * 1024
                                    ? `${(
                                        files.voteToWinImage.size / 1024
                                      ).toFixed(2)} KB`
                                    : `${(
                                        files.voteToWinImage.size /
                                        (1024 * 1024)
                                      ).toFixed(2)} MB`}
                                </p>
                              </div>
                            </div>
                            <div
                              className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 rounded-full bg-[#393939] cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:bg-red-700"
                              onClick={() =>
                                clearFileChange("voteToWinImage")
                              }
                            >
                              <IoClose className="text-secondary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
                            </div>
                          </div>
                        ) : (
                          <>
                            <img src={Icons.uploadIcon} alt="upload" />
                            <div className="xs:pt-1 lg:pt-3 text-center">
                              <label
                                htmlFor="voteToWinImage_Upload"
                                className="font-onestRegular xs:text-sm text-[#808080] cursor-pointer"
                              >
                                Drag & Drop or Click to Upload Banner
                              </label>
                              <input
                                id="voteToWinImage_Upload"
                                type="file"
                                accept="image/*"
                                name="voteToWinImage"
                                onChange={handleFileChange}
                                className="hidden"
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div className="flex justify-start items-center pt-1.5">
                        {!files.voteToWinImage &&
                          !userprofile?.vote_to_win_image && (
                            <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
                              Vote To Win Image is required
                            </span>
                          )}
                      </div>
                    </>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="flex justify-end sm:w-[85%] xs:w-full lg:w-[70%] items-center my-5 sm:my-8">
            <HoverButton
              extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md`}
              BtnTitle="Change Password"
              disabled={loadingToapi}
              type={"button"}
              onClick={() => navigate("/change-password")}
              BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                loadingToapi ||
                (isVoteToWinRequired && !isVoteToWinImageSelected)
                  ? ""
                  : "group-hover:scale-110 group-hover:text-primary"
              }`}
            />
          </div>
          <div className="flex justify-center flex-col items-center mb-5 lg:mb-8">
            <HoverButton
              extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md`}
              BtnTitle={
                loadingToapi ? (
                  <div className="flex justify-center items-center">
                    <div
                      className={`animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8`}
                    ></div>
                  </div>
                ) : (
                  "Submit"
                )
              }
              disabled={
                loadingToapi ||
                (isVoteToWinRequired && !isVoteToWinImageSelected)
              }
              type={"submit"}
              BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                loadingToapi ||
                (isVoteToWinRequired && !isVoteToWinImageSelected)
                  ? ""
                  : "group-hover:scale-110 group-hover:text-primary"
              }`}
            />
          </div>
        </form>
      </div>

      {/* Image Cropper Modal */}
      <Modal
        isOpen={cropperOpen}
        onRequestClose={handleCropCancel}
        contentLabel="Image Cropper"
        className="w-full max-w-3xl mx-auto bg-[#1A1A1A] rounded-lg shadow-xl overflow-hidden"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      >
        <div className="relative">
          {/* Header */}
          <div className="bg-[#212121] px-6 py-4 border-b border-gray-700 flex justify-between items-center">
            <h2 className="text-white text-xl font-semibold">
              {getCropperTitle()}
            </h2>
            <button
              onClick={handleCropCancel}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <IoClose size={24} />
            </button>
          </div>

          {/* Cropper */}
          <div className="relative w-full h-96 bg-black">
            <Cropper
              image={imageToCrop}
              crop={crop}
              zoom={zoom}
              aspect={getCropperAspectRatio()}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          {/* Controls */}
          <div className="bg-[#212121] px-6 py-4 space-y-4">
            <div>
              <label className="text-white text-sm mb-2 block">Zoom</label>
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(e.target.value)}
                className="w-full accent-[#D4AF37]"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-4">
              <button
                onClick={handleCropCancel}
                className="px-6 py-2 bg-gray-600 text-white rounded-full hover:bg-gray-700 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleCropSave}
                className="px-6 py-2 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-black font-semibold rounded-full hover:scale-105 transition-transform"
              >
                Apply Crop
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default ProfileInformation;